module.exports = __webpack_public_path__ + "static/media/24-7.ca2b01f1.svg";